<span class="text-large-semibold no-wrap" *ngIf="!processing"><ng-content></ng-content></span>
<img src="../../assets/button_spinner.png" class="button-spinner" *ngIf="processing" width="24" height="24px"/>